import React from 'react';
import { Grid } from '@lionstep/ui';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './generateTextDrawer.module.scss';

const GeneratedTextItem = ({ title, current, generated }) => (
  <Grid.Row className={styles.generatedTextItem} gutter={16}>
    <Grid.Col xs={24} className={styles.generatedTextItemTitle}>
      {title}
    </Grid.Col>
    <Grid.Col xs={12} className={styles.generatedTextItemTitleSecondary}>
      Current
    </Grid.Col>
    <Grid.Col xs={12} className={styles.generatedTextItemTitleSecondary}>
      Generated
    </Grid.Col>
    <Grid.Col
      xs={12}
      className={styles.generatedTextItemContent}
      dangerouslySetInnerHTML={{ __html: current }}
    />
    <Grid.Col
      xs={12}
      className={styles.generatedTextItemContent}
      dangerouslySetInnerHTML={{ __html: generated }}
    />
  </Grid.Row>
);

const GeneratedTextDisplay = ({
  extraInfo,
  generatedText,
  killerQuestions,
  optionalQuestions,
}) => {
  const { t } = useTranslation();

  const generatedTextItems = [
    {
      key: 'introduction',
      title: t(
        'job_description_page.summary_section.introduction_paragraph.label',
      ),
      current: extraInfo?.introduction,
      generated: generatedText?.texts?.introduction,
    },
    {
      key: 'summary',
      title: t('job_description_page.summary_section.summary.label'),
      current: extraInfo?.summary,
      generated: generatedText?.texts?.summary,
    },
    {
      key: 'your_role',
      title: t('job_description_page.summary_section.your_role.label'),
      current: extraInfo?.your_role,
      generated: generatedText?.texts?.role_tasks,
    },
    {
      key: 'requirements',
      title: t('job_description_page.requirements_section.must_have.label'),
      current: extraInfo?.requirements,
      generated: generatedText?.texts?.must_have,
    },
    {
      key: 'nice_to_have',
      title: t('job_description_page.requirements_section.nice_to_have.label'),
      current: extraInfo?.nice_to_have,
      generated: generatedText?.texts?.nice_to_have,
    },
    {
      key: 'team_desc',
      title: t('job_description_page.team_section.team_desc.label'),
      current: extraInfo?.team_desc,
      generated: generatedText?.texts?.team,
    },
    // {
    //   key: 'additional_benefits',
    //   title: t('job_description_page.benefits_section.additional_bonus.label'),
    //   current: extraInfo?.additional_benefits,
    //   generated: generatedText?.texts?.additional_benefits,
    // },
    {
      key: 'searcher_info',
      title: 'Searcher Info',
      current: extraInfo?.searcher_info,
      generated: generatedText?.texts?.searcher_info,
    },
  ].filter((item) => item.current);

  return (
    <Grid.Container fluid>
      {generatedTextItems.map((item, index) => (
        <React.Fragment key={item.key}>
          <GeneratedTextItem
            title={item.title}
            current={item.current}
            generated={item.generated}
          />
          {index < generatedTextItems.length - 1 ||
            ((killerQuestions?.length > 0 || optionalQuestions?.length > 0) && (
              <Grid.Row>
                <Grid.Col xs={24}>
                  <div className={styles.divider} />
                </Grid.Col>
              </Grid.Row>
            ))}
        </React.Fragment>
      ))}
    </Grid.Container>
  );
};

export default GeneratedTextDisplay;
